module.exports = new __parcel__URL__("ride_1.b04f8857.mp3").toString();